import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UndoableItem from "./UndoableItem.jsx";
import TransactionRenderKey from "../../../utilities/TransactionRenderKey.jsx";

export default function TransactionEditUndo({ transactionSubmit }) {
	const dispatch = useDispatch();
	const lastEditedTransaction = useSelector((state) => state.dashboard.replacedTransaction);

	function getItemId(transaction) {
		return TransactionRenderKey.getKey(transaction, {
			[TransactionRenderKey.TYPE_PLAID]: true,
			[TransactionRenderKey.TYPE_TRANSACTION_ID]: true,
			[TransactionRenderKey.TYPE_SUBMIT_ID]: true
		});
	}

	function undoButtonClicked(transaction) {
		transactionSubmit(transaction);
	}

	function getName(transaction) {
		return transaction.where;
	}

	function itemHasChangeThatCanBeUndone(item) {
		return true;
	}

	return (
		<UndoableItem
			item={lastEditedTransaction}
			getItemId={getItemId}
			itemHasChangeThatCanBeUndone={itemHasChangeThatCanBeUndone}
			undoButtonClicked={undoButtonClicked}
			afterClickedUndoContent={(budget) => {
				return `Restored ${getName(budget)}`;
			}}
			canUndoContent={(budget) => {
				return (
					<span>Updated Transaction <span className='institution_name'>{getName(budget)}</span></span>
				);
			}}
		/>
	);
}